import { makeStyles } from '@mui/styles';

export function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        value: index,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    tabPanel: {
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            height: 'calc(75vh - 64px)',
            overflowY: 'scroll',
        },
    },

    tabPanelFullHeight: {
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            height: '75vh',
            overflowY: 'scroll',
        },
    },
}));
export function TabPanel(props) {
    const classes = useStyles();
    const { children, value, index, ...other } = props;
    const idPrefix = other.idprefix || 'full-width-tab';
    const withButtonSpacing = props.buttonBoxSpacing ? classes.tabPanel : classes.tabPanelFullHeight;

    return (
        <div role="tabpanel" hidden={value !== index} id={`${idPrefix}panel-${index}`} aria-labelledby={`${idPrefix}-${index}`} className={props.className ? props.className : withButtonSpacing} {...other}>
            {value === index && children}
        </div>
    );
}

export default TabPanel;
